// PROJECTA GOAL — "+ Add" buttons of the cart drawer upsell. Adds the product and refreshes the drawer
// through the theme's own cart event, so the item list, totals and rewards bar update in place.
import { CartLinesUpdateEvent } from '@shopify/events';

document.addEventListener('click', async (e) => {
  const btn = e.target.closest('[data-pv-upsell-add]');
  if (!btn) return;
  e.preventDefault();
  const box = btn.closest('[data-pv-upsell]');
  const id = Number(btn.dataset.pvUpsellAdd);
  const label = btn.innerHTML;
  btn.disabled = true;
  btn.textContent = '…';

  const sectionIds = [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
  const deferred = CartLinesUpdateEvent.createPromise();
  btn.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'cart', lines: [{ merchandiseId: String(id), quantity: 1 }], promise: deferred.promise }));

  try {
    const res = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity: 1 }], sections: sectionIds.join(',') }),
    });
    const data = await res.json();
    const cart = await fetch(`${Theme.routes.cart_url}.js`).then((r) => r.json());
    const failed = !res.ok || data.status;
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: failed
        ? { didError: true, items: cart.items, source: 'pv-cart-upsell' }
        : { items: cart.items, source: 'pv-cart-upsell', itemCount: 1, sections: data.sections, didError: false },
    });
    if (failed) throw new Error(data.description || data.message);
  } catch (err) {
    btn.disabled = false;
    btn.innerHTML = label;
    if (box && box.dataset.error) alert(box.dataset.error);
  }
});
